import api from "PFCore/api";

export type MarkNotificationsPayload = {
  categories?: string[];
  excludedCategories?: string[];
  roleId?: number;
  engagementId?: number;
};

export const markNotificationsAsRead = ({
  categories,
  excludedCategories,
  roleId,
  engagementId
}: MarkNotificationsPayload) =>
  api({
    url: "notifications/mark_as_read",
    method: "PUT",
    params: {
      roleId,
      engagementId,
      categories,
      excludedCategories
    }
  });
